import { render, staticRenderFns } from "./BakIngredientCombo.vue?vue&type=template&id=25fc0435&scoped=true"
import script from "./BakIngredientCombo.vue?vue&type=script&lang=js"
export * from "./BakIngredientCombo.vue?vue&type=script&lang=js"
import style0 from "./BakIngredientCombo.vue?vue&type=style&index=0&id=25fc0435&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25fc0435",
  null
  
)

export default component.exports